import { Api } from "@/utils/http/types";
import { RequestEnum } from "@/enums/httpEnum";

const CateApis = {
  selectCateList: new Api({
    url: "/api/cate/selectList",
    desc: "条件查询",
    method: RequestEnum.GET
  }),
  selectCateById: new Api({
    url: "/api/cate/selectById",
    desc: "根据ID查询",
    method: RequestEnum.GET
  }),
  selectAllCate: new Api({
    url: "/api/cate/selectAll",
    desc: "查询所有",
    method: RequestEnum.GET
  }),
  selectPageCate: new Api({
    url: "/api/cate/selectByPage",
    desc: "分页查询",
    method: RequestEnum.GET
  }),
  saveOrUpdateCate: new Api({
    url: "/api/cate/saveOrUpdate",
    desc: "保存或更新",
    method: RequestEnum.POST
  }),
  deleteCate: new Api({
    url: "/api/cate/delete",
    desc: "删除",
    method: RequestEnum.DELETE
  })
};

export default CateApis;

export interface Cate {
  id?: number;
  parentId?: number;
  name?: string;
  description?: string;
  sequence?: number;
  status?: number;
  type?: number;
  children?: Array<Cate>;
  createTime?: string;
  updateTime?: string;
}

export interface Tree {
  title?: string;
  value?: number;
  key?: number;
  children?: Tree[];
}

/**
 * 数组转换为树形结构
 */
export function transferArrayToTree(cates: Array<Cate>): Array<Tree> {
  const nodes: Array<Tree> = [];
  for (const cate of cates) {
    const node: Tree = {
      title: cate.name,
      value: cate.id,
      key: cate.id,
      children: []
    };
    if (cate.children) {
      node.children = transferArrayToTree(cate.children);
    }
    nodes.push(node);
  }
  return nodes;
}
